import moment from "moment";

export const DAY_MONTH_YEAR = "DD MMM YYYY";
export const YEAR_MONTH_DAY = "YYYY-MM-DD";
export const YEAR_MONTH_DAY_2 = "YYYY/MM/DD";
export const YEAR_MONTH_DAY_HOUR_MINUTE_SECOND = "YYYY-MM-DD HH:mm:ss";
export const YEAR_MONTH_DAY_HOUR_MINUTE = "YYYY-MM-DD hh:mmA";
export const FULL_DATE_TIME_FORMAT = "DD MMM YYYY hh:mm A";
// export const FULL_DATE_TIME_FORMAT2 = "DD MMMM YYYY, hh:mma";
export const FULL_DATE_TIME_FORMAT2 = "DD MMM YYYY, hh:mma";
export const TIME_FORMAT = "h:mm A"; // 1:00 PM

const SUNDAY = 0;
const SATURDAY = 6;
const WEEKENDS = [SATURDAY, SUNDAY];

export function addBusinessDays(stringDate, numberOfDays) {
  const date = moment(stringDate, YEAR_MONTH_DAY);

  let count = 0;

  while (count < numberOfDays) {
    date.add(1, "day");
    if (WEEKENDS.includes(date.day())) {
      continue;
    }
    count++;
  }

  return date.format(YEAR_MONTH_DAY);
}
